import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from '@components/button';
import { CsIconModule } from '@components/icon';
import { CannotCancelOrderComponent } from './cannot-cancel-order.component';

@NgModule({
  imports: [
    CommonModule,
    ButtonModule,
    CsIconModule,
    FormsModule,
  ],
  declarations: [CannotCancelOrderComponent],
  exports: [CannotCancelOrderComponent],
})

export class CannotCancelOrderModule { }
